<template>
	<div
		class="allCenteredChild px-4 py-2 white--text"
		style="background: #233b5d"
	>
		Contact Support: +91 6360217315
		<v-icon @click="callSupport" class="mx-2 ml-4 white--text" size="20">
			call
		</v-icon>
		<v-icon @click="whatsappSupport" class="mx-2 white--text" size="20">
			whatsapp
		</v-icon>
	</div>
</template>

<script>
export default {
	methods: {
		callSupport() {
			window.open("tel:+916360217315");
		},
		whatsappSupport() {
			window.open("https://wa.me/916360217315");
		}
	}
};
</script>
